/**
 * Created by Jerker Nord on 2022-04-05.
 */
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {TheBorder} from "../../TheBorder";
import {TheBorderGameMode} from "../../server/TheBorderGameMode";
import {TheBorderSound} from "../../sound/TheBorderSound";
import {BigWinLevel, TheBorderWinConfigs} from "../../configs/TheBorderWinConfigs";
import {TheBorderSymbol} from "../../reels/TheBorderSymbol";

export class TheBorderBigWinRunner implements SimplePresentation {

    constructor() {

    }

    private static getLevelSound(level:number):string {
        return TheBorderSound.BIG_WIN_EFFECTS[level];
    }

    private static getBigWinIntro(duration:number):gsap.core.Timeline {
        const tl = gsap.timeline();
        const symbols = TheBorder.allReelsView.getAllVisibleSymbols();

        for(let symbol of symbols) {
            tl.add((<TheBorderSymbol>symbol).getShakeAnimation(duration), 0);
        }

        return tl;
    }

    public shouldRun():boolean {
        return (TheBorderGameMode.isEndOfAvalanche(TheBorder.model.gameData.mode, TheBorder.model.gameData.nextMode) && TheBorder.model.winRatio >= 15 && !TheBorder.model.data.brokeBank);
    }

    public start(controller:SimplePresentationRunnerController):void {
        let levels:BigWinLevel[] = [];
        if(TheBorder.model.data.mode == TheBorderGameMode.FREESPIN_AVALANCHE && (TheBorder.model.data.nextMode == TheBorderGameMode.FREESPIN || TheBorder.model.data.nextMode == TheBorderGameMode.NORMAL) && TheBorder.model.winRatio >= 15 && !TheBorder.model.data.brokeBank) {
            levels = TheBorderWinConfigs.getBigWinLevels(TheBorder.model.winRatio);
        }
        if(TheBorder.model.data.mode == TheBorderGameMode.NORMAL_AVALANCHE && TheBorder.model.data.nextMode == TheBorderGameMode.NORMAL && TheBorder.model.winRatio >= 15 && !TheBorder.model.data.brokeBank) {
            levels = TheBorderWinConfigs.getBigWinLevels(TheBorder.model.winRatio);
        }
        if(TheBorder.model.winRatio >= 100 && TheBorder.model.data.mode == TheBorderGameMode.SUPER_FREESPIN_AVALANCHE && (TheBorder.model.data.nextMode == TheBorderGameMode.SUPER_FREESPIN || TheBorder.model.data.nextMode == TheBorderGameMode.NORMAL) && !TheBorder.model.data.brokeBank) {
            levels = TheBorderWinConfigs.getBigWinLevelsSuperFS(TheBorder.model.winRatio);
        }

        const tl:gsap.core.Timeline = gsap.timeline({onComplete : () => controller.finish()});
        if(levels.length > 0) {
            TheBorder.bigWinView.precalculateScale(TheBorder.model.winRatio * TheBorder.model.gameData.playedBetValue);

            let introDuration = 1; // #86
            let levelAborted = false;
            for(let level of levels) {
                const levelSound = TheBorderBigWinRunner.getLevelSound(level.id);
                tl.add(() => {
                    levelAborted = false;
                });
                if(level.id == 1) {
                    tl.add(() => {
                        TheBorder.soundPlayer.playSound(TheBorderSound.BIG_WIN_EFFECTS[0]);
                        TheBorder.soundPlayer.playNonLoopSound(TheBorderSound.BIG_WIN_MUSICS[0]);

                        TheBorder.soundPlayer.fadeMusic({
                            name : "",
                            duration : 300,
                            to : 0
                        });
                    });
                    tl.add(TheBorderBigWinRunner.getBigWinIntro(introDuration));
                }
                tl.add(() => controller.setSkipCallback(() => {
                    levelAborted = true;
                    tl.seek(level.name + "_end", false);
                }));

                tl.add(TheBorder.bigWinView.getLevelAnimation(level.from * TheBorder.model.gameData.playedBetValue, level.to * TheBorder.model.gameData.playedBetValue, level.duration, level.id));
                tl.addLabel(level.name + "_end");
                tl.add(() => controller.setSkipCallback());
                tl.add(() => {
                    if(levelAborted) {
                        TheBorder.soundPlayer.stopSound(levelSound);
                        TheBorder.soundPlayer.stopSound(TheBorderSound.BIG_WIN_MUSICS[level.id]);
                    } else {
                        TheBorder.soundPlayer.fadeOutEffect({
                            name : levelSound,
                            duration : 100,
                            to : 0
                        });
                    }
                });
            }

            tl.add(TheBorder.bigWinView.show(introDuration * 0.7), introDuration - (introDuration * 0.7));
            tl.add(() => {
                TheBorder.keypadPlugin.setWin(TheBorder.model.data.accumulatedRoundWin, true, TheBorder.isWinBelowStake());

                TheBorder.soundPlayer.playSound(TheBorderSound.BIG_WIN_END);
                TheBorder.soundPlayer.playNonLoopSound(TheBorderSound.BIG_WIN_MUSIC_END);
                TheBorder.soundPlayer.fadeMusic({
                    name : "",
                    duration : 300,
                    to : 1
                });
            });
            tl.add(TheBorder.bigWinView.hide(0.5), ">1.5");
        }
    }
}